<!-- add an x-close-button to right top corner  that will be on top of everything -->
<!-- <div
	style="
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 40px;
		z-index: 9000;
		align-items: center;
		justify-content: right;
		display: flex;
		pointer-events: none;
	"
	*ngIf="HasOtherModalsOpen()"
>
	<nav class="navbar navbar-expand-lg ms-1">
		<ul class="navbar-nav">
			<li class="nav-item">
				
			</li>
		</ul>
		<div class="navbar-text ms-auto me-3">
			<button
				type="button"
				class="btn-close"
				style="pointer-events: all"
				aria-label="Close"
				(click)="closeModal()"
			></button>
			
		</div>
	</nav>
</div> -->

<div class="container my-4">
	<ul ngbNav class="nav-tabs">
		<li ngbNavItem role="presentation">
			<h3>
				<i class="bi bi-play-circle-fill me-1 text-primary"></i>
				@if (!showArchived) {
					Luodut pelit
				} @else {
					Arkistoidut pelit
				}
			</h3>
		</li>

		<li ngbNavItem class="pe-2 ms-auto">
			<label class="form-label pe-2 d-none d-lg-inline">Näytä</label>
			<div class="btn-group me-3" role="group">
				<input
					type="checkbox"
					class="btn-check"
					id="filterNotShared"
					[(ngModel)]="showNotShared"
					(ngModelChange)="updateShareFilters()"
					name="filterNotShared"
					autocomplete="off"
				/>
				<label
					class="btn btn-outline-secondary btn-sm"
					for="filterNotShared"
					ngbTooltip="Näytä julkaisemattomat pelit"
					[openDelay]="350"
				>
					<i class="bi bi-floppy"></i>
				</label>

				<input
					type="checkbox"
					class="btn-check"
					id="filterShared"
					[(ngModel)]="showShared"
					(ngModelChange)="updateShareFilters()"
					name="filterShared"
					autocomplete="off"
				/>
				<label
					class="btn btn-outline-secondary btn-sm"
					for="filterShared"
					ngbTooltip="Näytä julkaistut pelit"
					[openDelay]="350"
				>
					<i class="bi bi-share"></i>
				</label>
			</div>
			<div class="btn-group me-3" role="group">
				<input
					type="checkbox"
					class="btn-check"
					id="filterArchived"
					[(ngModel)]="showArchived"
					(ngModelChange)="onShowArchivedChange()"
					name="filterArchived"
					autocomplete="off"
				/>
				<label
					class="btn btn-outline-secondary btn-sm"
					for="filterArchived"
					ngbTooltip="Näytä arkistoidut pelit"
					[openDelay]="350"
				>
					<i class="bi bi-archive"></i>
				</label>
			</div>
		</li>

		<li ngbNavItem class="pe-2">
			<form class="form-inline">
				<input
					class="form-control mr-sm-2"
					type="search"
					placeholder="Hae"
					aria-label="Hae"
					[(ngModel)]="searchText"
					name="searchText"
				/>
			</form>
		</li>

		<li ngbNavItem>
			<div
				class="col-auto d-flex gap-2"
				*ngIf="
					!exportService.IsLoading && !hasError && exports.length > 0
				"
			>
				<div ngbDropdown>
					<button
						class="btn btn-sm btn-outline-secondary"
						ngbDropdownToggle
					>
						<i class="bi bi-three-dots-vertical"></i>
					</button>
					<div ngbDropdownMenu>
						<button
							ngbDropdownItem
							(click)="checkAllExportsCompatibility()"
						>
							<i class="bi bi-arrow-repeat me-2"></i>
							Korjaa monta peliä...
						</button>

						<button
							ngbDropdownItem
							(click)="confirmBulkArchive(bulkArchiveModal)"
							[disabled]="selectedExports.size === 0"
						>
							<i class="bi bi-archive me-2"></i>
							Arkistoi valitut pelit...
						</button>
						<div class="dropdown-divider"></div>
						<button
							ngbDropdownItem
							(click)="confirmBulkDelete(bulkDeleteModal)"
							[disabled]="selectedExports.size === 0"
							class="text-danger"
						>
							<i class="bi bi-trash me-2"></i>
							Poista valitut pelit...
						</button>

						<!-- <button
							ngbDropdownItem
							(click)="openDeleteAllModal()"
							class="text-danger"
						>
							<i class="bi bi-exclamation-triangle me-1"></i>
							Poista kaikki pelit...
						</button> -->
					</div>
				</div>
			</div>
		</li>
	</ul>

	<!-- Loading spinner -->
	<div class="row" *ngIf="exportService.IsLoading">
		<div class="col-12 text-center py-5">
			<div
				class="spinner-border text-primary"
				role="status"
				style="width: 3rem; height: 3rem"
			>
				<span class="visually-hidden">Ladataan...</span>
			</div>
			<p class="mt-3">Ladataan pelejä...</p>
		</div>
	</div>

	<!-- Error message -->
	<div class="row" *ngIf="hasError">
		<div class="col-12">
			<div class="alert alert-danger" role="alert">
				<h4 class="alert-heading">Virhe!</h4>
				<p>{{ errorMessage }}</p>
				<hr />
				<p class="mb-0">
					Yritä päivittää sivu uudelleen tai ota yhteyttä tukeen.
				</p>
			</div>
		</div>
	</div>

	<!-- No content message -->

	<!-- Unsaved Batch Results Section -->
	<div class="mt-4 position-relative" *ngIf="unsavedBatchJobs.length > 0">
		<h5 class="text-muted mb-3 d-flex align-items-center">
			<i class="bi bi-clock-history me-2"></i>Tallentamattomat<span
				class="badge bg-warning text-dark ms-2"
				>{{ unsavedBatchJobs.length }}</span
			>
		</h5>
		<div class="w-100">
			<table class="table table-hover table-sm w-100 mb-4">
				<thead>
					<tr>
						<th scope="col">Nimi</th>
						<th
							scope="col"
							style="width: 150px; white-space: nowrap"
						>
							Tyyppi
						</th>
						<th
							scope="col"
							style="width: 170px; white-space: nowrap"
						>
							Aloitettu
						</th>
						<th
							scope="col"
							class="text-end"
							style="width: 220px; white-space: nowrap"
						></th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="let job of unsavedBatchJobs"
						[style.cursor]="
							job.status === 'completed' ? 'pointer' : 'default'
						"
						(click)="
							job.status === 'completed' && playBatchJob(job)
						"
					>
						<td>
							<div class="d-flex align-items-center ms-2">
								<!-- Progress wheel for in-progress jobs -->
								<span
									*ngIf="
										job.status === 'queued' ||
										job.status === 'processing'
									"
									class="me-3 text-dark"
								>
									<app-progress-wheel
										class="ms-n1"
										[progress]="getJobProgress(job.id)"
									></app-progress-wheel>
								</span>

								<!-- Success check icon for completed jobs -->
								<i
									*ngIf="
										job.status === 'completed' &&
										getBatchJobCompatibilityStatus(job.id)
											.isCompatible
									"
									class="bi bi-check-circle-fill fs-4 text-success me-3"
									title="Valmis"
								></i>

								<!-- Error icon for failed jobs -->
								<i
									*ngIf="job.status === 'failed'"
									class="bi bi-trash-circle-fill fs-4 text-danger me-3"
									[ngbTooltip]="
										job.error ||
										'Pelin luominen epäonnistui'
									"
									placement="top"
									triggers="hover"
									title="Epäonnistui"
								></i>

								<!-- Warning icon for incompatible completed jobs -->
								<i
									*ngIf="
										job.status === 'completed' &&
										!getBatchJobCompatibilityStatus(job.id)
											.isCompatible &&
										!getBatchJobCompatibilityStatus(job.id)
											.isChecking
									"
									class="bi bi-exclamation-triangle-fill text-warning me-3 d-inline-block"
									[ngbTooltip]="
										getBatchJobCompatibilityStatus(job.id)
											.error ||
										'Peli on yhteensopimaton nykyisen version kanssa'
									"
									placement="top"
									triggers="hover"
									title="Yhteensopivuusongelma"
								></i>

								<!-- Loading indicator while checking compatibility -->
								<span
									*ngIf="
										job.status === 'completed' &&
										getBatchJobCompatibilityStatus(job.id)
											.isChecking
									"
									class="spinner-border spinner-border-sm text-secondary me-3"
									role="status"
									aria-hidden="true"
									title="Tarkistetaan yhteensopivuutta..."
								></span>

								<div>
									<div
										class="fw-medium flex align-items-center"
										[ngClass]="{
											'text-muted':
												job.status === 'failed',
										}"
									>
										{{ job.gameName }}

										<!-- Status badge for in-progress jobs -->
										<span
											*ngIf="
												job.status === 'queued' ||
												job.status === 'processing'
											"
											class="badge small ms-2"
											[ngClass]="{
												'bg-warning':
													job.status === 'queued',
												'bg-primary':
													job.status === 'processing',
											}"
										>
											{{
												job.status === "queued"
													? "Jonossa"
													: "Luodaan"
											}}
										</span>
									</div>
								</div>
							</div>
						</td>
						<td>
							<span class="text-muted">
								{{
									getPluginTypeDisplayName(
										job.result?.gameData?.type ||
											job.gameType
									)
								}}
							</span>
						</td>
						<td>
							<span class="text-muted">
								{{
									job.status === "completed" ||
									job.status === "failed"
										? (job.completedAt!
											| date: "d.M.yyyy HH:mm")
										: (job.createdAt
											| date: "d.M.yyyy HH:mm")
								}}
							</span>
						</td>
						<td class="text-end" (click)="$event.stopPropagation()">
							<!-- Actions for completed jobs -->
							<!-- <button
								*ngIf="job.status === 'completed'"
								type="button"
								class="btn btn-outline-secondary btn-sm me-2"
								(click)="playBatchJob(job)"
								title="Esikatsele"
							>
								<i class="bi bi-eye"></i>
							</button> -->
							<button
								*ngIf="job.status === 'completed'"
								type="button"
								class="btn btn-outline-success btn-sm"
								(click)="saveBatchJob(job)"
								title="Tallenna"
							>
								<i class="bi bi-floppy"></i>
							</button>
							<button
								*ngIf="job.status === 'completed'"
								type="button"
								class="btn btn-outline-secondary btn-sm"
								(click)="playBatchJob(job)"
								title="Pelaa"
							>
								<i class="bi bi-play-fill"></i>
							</button>
							<button
								*ngIf="job.status === 'completed'"
								type="button"
								class="btn btn-outline-secondary btn-sm"
								(click)="editBatchJob(job)"
								title="Muokkaa"
							>
								<i class="bi bi-pencil"></i>
							</button>

							<!-- Cancel button for in-progress jobs -->
							<!-- <button
									*ngIf="job.status === 'queued' || job.status === 'processing'"
									type="button"
									class="btn btn-outline-danger btn-sm"
									(click)="cancelBatchJob(job)"
									title="Peruuta tehtävä"
								>
									<i class="bi bi-trash-circle"></i>
								</button> -->

							<!-- Cancel/Delete button for all jobs -->
							<button
								type="button"
								class="btn btn-outline-danger btn-sm"
								[disabled]="batchJobsBeingCancelled.has(job.id)"
								(click)="
									job.status === 'queued' ||
									job.status === 'processing'
										? cancelAndDeleteBatchJob(job)
										: deleteBatchJob(job)
								"
								[title]="
									batchJobsBeingCancelled.has(job.id)
										? 'Peruutetaan...'
										: job.status === 'completed' ||
											  job.status === 'failed'
											? 'Poista'
											: 'Peruuta ja poista'
								"
							>
								<span
									*ngIf="batchJobsBeingCancelled.has(job.id)"
									class="spinner-border spinner-border-sm"
									role="status"
									aria-hidden="true"
								></span>
								<i
									*ngIf="!batchJobsBeingCancelled.has(job.id)"
									class="bi bi-trash"
								></i>
							</button>

							<!-- 3-dot dropdown menu with all actions -->
							<div
								class="btn-group always-visible me-0"
								ngbDropdown
								container="body"
								role="group"
							>
								<button
									class="btn btn-outline-secondary btn-sm me-0"
									ngbDropdownToggle
									(click)="$event.stopPropagation()"
									title="Lisää toimintoja"
								>
									<i class="bi bi-three-dots-vertical"></i>
								</button>

								<div ngbDropdownMenu>
									<!-- Play -->
									<button
										ngbDropdownItem
										*ngIf="job.status === 'completed'"
										(click)="
											$event.stopPropagation();
											playBatchJob(job)
										"
									>
										<i class="bi bi-play-fill me-2"></i>
										Pelaa
									</button>

									<!-- Save -->
									<button
										ngbDropdownItem
										*ngIf="job.status === 'completed'"
										(click)="
											$event.stopPropagation();
											saveBatchJob(job)
										"
									>
										<i class="bi bi-floppy me-2"></i>
										Tallenna
									</button>

									<!-- Edit -->
									<button
										ngbDropdownItem
										*ngIf="job.status === 'completed'"
										(click)="
											$event.stopPropagation();
											editBatchJob(job)
										"
									>
										<i class="bi bi-pencil me-2"></i>
										Muokkaa
									</button>

									<div class="dropdown-divider"></div>

									<!-- Delete/Cancel -->
									<button
										ngbDropdownItem
										class="text-danger"
										(click)="
											$event.stopPropagation();
											job.status === 'queued' ||
											job.status === 'processing'
												? cancelAndDeleteBatchJob(job)
												: deleteBatchJob(job)
										"
										[disabled]="
											batchJobsBeingCancelled.has(job.id)
										"
									>
										<span
											*ngIf="
												!batchJobsBeingCancelled.has(
													job.id
												)
											"
										>
											<i class="bi bi-trash me-2"></i>
											{{
												job.status === "completed" ||
												job.status === "failed"
													? "Poista"
													: "Peruuta ja poista"
											}}
										</span>
										<span
											*ngIf="
												batchJobsBeingCancelled.has(
													job.id
												)
											"
											class="d-flex align-items-center"
										>
											<span
												class="spinner-border spinner-border-sm me-2"
												role="status"
												aria-hidden="true"
											></span>
											Peruutetaan...
										</span>
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<div
		class="row"
		*ngIf="!exportService.IsLoading && !hasError && exports.length === 0"
	>
		<div class="col-12 text-center py-5">
			<ng-container *ngIf="exportService.Error === ''">
				<h3 class="pt-5 mb-4">Ei tallennettuja pelejä.</h3>
				<p>Aloita pelien luominen Tiedostot-näkymästä.</p>
			</ng-container>

			<div
				class="alert alert-danger"
				role="alert"
				*ngIf="exportService.Error !== ''"
			>
				<h4 class="alert-heading">Virhe!</h4>
				<p>{{ exportService.Error }}</p>
				<hr />
				<p class="mb-0">
					Yritä päivittää sivu uudelleen tai ota yhteyttä tukeen.
				</p>
			</div>
		</div>
	</div>

	<!-- Content as Table -->
	<div
		class="mt-4 position-relative"
		*ngIf="!exportService.IsLoading && !hasError && exports.length > 0"
	>
		<h5 class="text-muted mb-3" *ngIf="unsavedBatchJobs.length > 0">
			<i class="bi bi-floppy me-2"></i>Tallennetut
		</h5>
		<div class="w-100">
			<table class="table table-hover w-100">
				<thead>
					<tr>
						<th scope="col">
							<button
								class="btn btn-sm btn-outline-secondary me-2"
								(click)="selectAllExports()"
								title="Valitse kaikki"
							>
								<i class="bi bi-check"></i>
							</button>
						</th>
						<th
							scope="col"
							class="sortable-header"
							(click)="sortExports('name')"
						>
							Nimi
							<i class="ms-1" [ngClass]="getSortIcon('name')"></i>
						</th>
						<th
							scope="col"
							class="sortable-header"
							style="width: 150px; white-space: nowrap"
							(click)="sortExports('type')"
						>
							Tyyppi
							<i class="ms-1" [ngClass]="getSortIcon('type')"></i>
						</th>
						<!-- <th scope="col">Luoja</th> -->
						<th
							scope="col"
							class="sortable-header"
							style="width: 170px; white-space: nowrap"
							(click)="sortExports('date')"
						>
							Luotu
							<i class="ms-1" [ngClass]="getSortIcon('date')"></i>
						</th>
						<th
							scope="col"
							class="text-end"
							style="width: 220px; white-space: nowrap"
						></th>
					</tr>
				</thead>
				<tbody>
					<tr
						*ngFor="let export of filteredExports; let i = index"
						style="cursor: pointer"
						(click)="
							isOrphanedExport(export.id)
								? PlayOrphanedExport(export.id!)
								: PlayExport(export)
						"
					>
						<th scope="row" class="text-nowrap">
							<div class="form-check">
								<input
									class="form-check-input checkbox-lg"
									type="checkbox"
									[id]="'export_check' + i"
									[checked]="isExportSelected(export.id)"
									(click)="
										toggleExportSelection(export.id);
										$event.stopPropagation()
									"
								/>
								<label
									class="form-check-label"
									[for]="'export_check' + i"
								>
								</label>
							</div>
						</th>
						<td
							(mouseenter)="
								!isOrphanedExport(export.id) &&
									onRowMouseEnter(export, $event)
							"
							(mousemove)="
								!isOrphanedExport(export.id) &&
									onRowMouseMove($event)
							"
							(mouseleave)="
								!isOrphanedExport(export.id) &&
									onRowMouseLeave()
							"
						>
							<div class="d-flex align-items-center">
								<div class="d-flex align-items-center">
									<i
										*ngIf="isOrphanedExport(export.id)"
										class="bi bi-archive text-muted me-3"
										title="Arkistoitu (tallennusta ei enää ole)"
									></i>
									<span
										class="fw-medium"
										[class.text-muted]="
											isOrphanedExport(export.id)
										"
										>{{ export.name }}</span
									>

									<!-- Share count badge -->
									<span
										*ngIf="getShareCount(export.id) > 0"
										class="text-primary ms-2 d-flex align-items-center"
										(click)="
											$event.stopPropagation();
											ShareExport(export)
										"
									>
										<i
											class="bi bi-share"
											style="font-size: 1.2em"
										></i>
										<!-- {{
											getShareCount(export.id) > 1
												? getShareCount(export.id)
												: ""
										}} -->
									</span>

									<!-- Warning tooltip and fix button for incompatible exports -->
									<ng-container
										*ngIf="
											!getExportCompatibilityStatus(
												export.id
											).isCompatible &&
											!getExportCompatibilityStatus(
												export.id
											).isChecking
										"
									>
										<!-- Warning icon with tooltip -->
										<i
											class="bi bi-exclamation-triangle-fill text-warning ms-2"
											[ngbTooltip]="
												getExportCompatibilityStatus(
													export.id
												).error ||
												'Peli on yhteensopimaton ja vaatii muunnosta'
											"
											placement="top"
											triggers="hover"
											title="Yhteensopivuusongelma"
										></i>

										<!-- Fix button -->
										<button
											type="button"
											class="btn btn-sm btn-outline-warning ms-2 px-2 py-1"
											(click)="fixSingleExport(export)"
											title="Korjaa tämä peli"
										>
											<i
												class="bi bi-tools me-1"
												style="font-size: 0.8rem"
											></i>
											<small>Korjaa</small>
										</button>
									</ng-container>

									<!-- Loading indicator while checking -->
									<ng-container
										*ngIf="
											getExportCompatibilityStatus(
												export.id
											).isChecking
										"
									>
										<div
											class="spinner-border spinner-border-sm text-secondary ms-2"
											role="status"
											aria-label="Tarkistetaan..."
										>
											<span class="visually-hidden"
												>Tarkistetaan...</span
											>
										</div>
									</ng-container>
								</div>
							</div>
						</td>
						<td>
							<span class="text-muted">
								{{
									getPluginTypeDisplayName(
										export.gameData?.type
									)
								}}
							</span>
						</td>
						<!-- <td>{{ export.creator }}</td> -->
						<td>
							<span class="text-muted">
								{{
									export.date * 1000 | date: "d.M.yyyy HH:mm "
								}}
							</span>
						</td>
						<td class="text-end" (click)="$event.stopPropagation()">
							<!-- <button
								type="button"
								class="btn btn-outline-secondary btn-sm me-2"
								(click)="PlayExport(export)"
								title="Esikatsele"
								[disabled]="
									experiencesBeingDeleted.has(export.id)
								"
							>
								<i class="bi bi-eye"></i>
							</button> -->
							<button
								*ngIf="!isOrphanedExport(export.id)"
								type="button"
								class="btn btn-outline-secondary btn-sm"
								(click)="PlayExport(export)"
								title="Pelaa"
								[disabled]="
									experiencesBeingDeleted.has(export.id)
								"
							>
								<i class="bi bi-play-fill"></i>
							</button>
							<button
								*ngIf="!isOrphanedExport(export.id)"
								type="button"
								class="btn btn-outline-secondary btn-sm"
								(click)="EditExport(export)"
								title="Muokkaa"
								[disabled]="
									experiencesBeingDeleted.has(export.id)
								"
							>
								<i class="bi bi-pencil"></i>
							</button>
							<!-- <button
									type="button"
									class="btn btn-outline-secondary btn-sm"
									(click)="CopyExportToClipboard(export)"
									title="Kopioi leikepöydälle"
									[disabled]="
										experiencesBeingDeleted.has(export.id)
									"
								>
									<i class="bi bi-files"></i>
								</button> -->
							<button
								type="button"
								class="btn btn-outline-secondary btn-sm"
								(click)="ShareExport(export)"
								title="Julkaisu"
								[disabled]="
									experiencesBeingDeleted.has(export.id)
								"
							>
								<i class="bi bi-share"></i>
							</button>
							<!-- <button
									type="button"
									class="btn btn-outline-secondary btn-sm"
									(click)="ExportToPDF(export)"
									title="Vie PDF"
									[disabled]="
										experiencesBeingDeleted.has(export.id)
									"
								>
									<i class="bi bi-file-earmark-pdf"></i>
								</button> -->
							<button
								type="button"
								class="btn btn-outline-danger btn-sm"
								(click)="
									confirmDeleteExport(
										export,
										deleteExportModal
									)
								"
								title="Poista"
								[disabled]="
									experiencesBeingDeleted.has(export.id)
								"
							>
								<i
									class="bi bi-trash"
									*ngIf="
										!experiencesBeingDeleted.has(export.id)
									"
								></i>
								<span
									class="spinner-border spinner-border-sm m-0 p-0"
									*ngIf="
										experiencesBeingDeleted.has(export.id)
									"
									role="status"
									aria-hidden="true"
								></span>
							</button>

							<!-- 3-dot dropdown menu with all actions -->
							<div
								class="btn-group always-visible me-0"
								ngbDropdown
								container="body"
								role="group"
							>
								<button
									class="btn btn-outline-secondary btn-sm me-0"
									ngbDropdownToggle
									(click)="$event.stopPropagation()"
									title="Lisää toimintoja"
								>
									<i class="bi bi-three-dots-vertical"></i>
								</button>

								<div ngbDropdownMenu>
									<!-- Play -->
									<button
										ngbDropdownItem
										*ngIf="!isOrphanedExport(export.id)"
										(click)="
											$event.stopPropagation();
											PlayExport(export)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<i class="bi bi-play-fill me-2"></i>
										Pelaa
									</button>

									<!-- Edit -->
									<button
										ngbDropdownItem
										*ngIf="!isOrphanedExport(export.id)"
										(click)="
											$event.stopPropagation();
											EditExport(export)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<i class="bi bi-pencil me-2"></i>
										Muokkaa
									</button>

									<!-- Rename -->
									<button
										ngbDropdownItem
										*ngIf="!isOrphanedExport(export.id)"
										(click)="
											$event.stopPropagation();
											openRenameModal(export)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<i
											class="bi bi-input-cursor-text me-2"
										></i>
										Nimeä uudelleen
									</button>

									<div class="dropdown-divider"></div>

									<!-- Share -->
									<button
										ngbDropdownItem
										(click)="
											$event.stopPropagation();
											ShareExport(export)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<i class="bi bi-share me-2"></i>
										Julkaise...
									</button>

									<!-- Archive -->
									<button
										ngbDropdownItem
										*ngIf="!isOrphanedExport(export.id)"
										(click)="
											$event.stopPropagation();
											confirmArchiveExport(
												export,
												archiveExportModal
											)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<i
											[class]="
												exportService.isExportArchived(
													export.id
												)
													? 'bi bi-arrow-counterclockwise me-2'
													: 'bi bi-archive me-2'
											"
										></i>
										{{
											exportService.isExportArchived(
												export.id
											)
												? "Palauta päänäkymään..."
												: "Arkistoi..."
										}}
									</button>

									<div class="dropdown-divider"></div>

									<!-- Delete -->
									<button
										ngbDropdownItem
										class="text-danger"
										(click)="
											$event.stopPropagation();
											confirmDeleteExport(
												export,
												deleteExportModal
											)
										"
										[disabled]="
											experiencesBeingDeleted.has(
												export.id
											)
										"
									>
										<span
											*ngIf="
												!experiencesBeingDeleted.has(
													export.id
												)
											"
										>
											<i class="bi bi-trash me-2"></i>
											Poista
										</span>
										<span
											*ngIf="
												experiencesBeingDeleted.has(
													export.id
												)
											"
											class="d-flex align-items-center"
										>
											<span
												class="spinner-border spinner-border-sm me-2"
												role="status"
												aria-hidden="true"
											></span>
											Poistetaan...
										</span>
									</button>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<!-- Loading archived exports spinner -->
	<div
		class="row"
		*ngIf="exportService.IsLoadingArchivedExports && showArchived"
	>
		<div class="col-12 text-center py-5">
			<div
				class="spinner-border text-primary"
				role="status"
				style="width: 3rem; height: 3rem"
			>
				<span class="visually-hidden"
					>Ladataan arkistoituja pelejä...</span
				>
			</div>
			<p class="mt-3">Ladataan arkistoituja pelejä...</p>
		</div>
	</div>

	<!-- Preview container for hover preview -->
	<div class="preview-container" *ngIf="showPreview" [ngStyle]="previewStyle">
		<div class="preview-scaler">
			<ng-container #previewContainer></ng-container>
		</div>
	</div>
</div>

<!-- <ng-template #deleteAllModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-delete-title">Poista kaikki pelit</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-delete-title"
			(click)="modal.dismiss('Cross click')"
		></button>
	</div>
	<div class="modal-body">
		<p>
			Oletko varma, että haluat poistaa
			<strong>kaikki</strong> pelit? Tätä toimintoa ei voi peruuttaa.
		</p>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
		>
			Peruuta
		</button>

		<button
			type="button"
			class="btn btn-danger"
			(click)="deleteAllExperiences()"
		>
			<i class="bi bi-trash"></i> Poista kaikki
		</button>
	</div>
</ng-template> -->

<ng-template #deleteExportModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-delete-export-title">Poista peli</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-delete-export-title"
			(click)="modal.dismiss('Cross click')"
			[disabled]="deleteExportInProgress"
		></button>
	</div>
	<div class="modal-body">
		<!-- Loading state -->
		<div *ngIf="deleteExportInProgress" class="text-center py-3">
			<div class="spinner-border text-primary mb-3" role="status">
				<span class="visually-hidden">Poistetaan...</span>
			</div>
			<p class="mb-0">Poistetaan peliä ja julkaisua...</p>
		</div>

		<!-- Error state -->
		<div *ngIf="deleteExportError" class="alert alert-danger" role="alert">
			<h5 class="alert-heading">Virhe</h5>
			<p class="mb-0">{{ deleteExportError }}</p>
		</div>

		<!-- Confirmation state -->
		<div *ngIf="!deleteExportInProgress && !deleteExportError">
			<p class="text-muted">
				Oletko varma, että haluat poistaa pelin
				<strong>{{ exportToDelete?.name }}</strong
				>? Tämä poistaa myös pelin julkaisun.
				<!-- <span *ngIf="getShareCount(exportToDelete?.id) > 0">
					(<strong>{{ getShareCount(exportToDelete?.id) }}</strong>
					julkaisua) </span
				>. -->
			</p>

			<p class="text-danger">Poistettua peliä ei voi palauttaa.</p>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
			[disabled]="deleteExportInProgress"
		>
			{{ deleteExportError ? "Sulje" : "Peruuta" }}
		</button>

		<button
			*ngIf="!deleteExportError"
			type="button"
			class="btn btn-danger"
			(click)="executeDeleteExport(modal)"
			[disabled]="deleteExportInProgress"
		>
			<span
				*ngIf="deleteExportInProgress"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i *ngIf="!deleteExportInProgress" class="bi bi-trash me-1"></i>
			Poista peli
		</button>
	</div>
</ng-template>

<ng-template #renameModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-rename-title">Nimeä uudelleen</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-rename-title"
			(click)="modal.dismiss('Cross click')"
		></button>
	</div>
	<div class="modal-body">
		<form (ngSubmit)="submitRename()">
			<div class="mb-3">
				<label for="renameName" class="form-label">Pelin nimi</label>
				<input
					type="text"
					class="form-control"
					[class.is-invalid]="
						showRenameValidationErrors &&
						renameValidationErrors.length > 0
					"
					id="renameName"
					[(ngModel)]="renameName"
					(ngModelChange)="onRenameNameInput()"
					name="renameName"
					placeholder="Anna pelille nimi"
					required
					autofocus
				/>

				<!-- Validation error messages -->
				<div
					*ngIf="
						showRenameValidationErrors &&
						renameValidationErrors.length > 0
					"
					class="invalid-feedback d-block"
				>
					<div
						*ngFor="let error of renameValidationErrors"
						class="d-block"
					>
						{{ error }}
					</div>
				</div>

				<div
					*ngIf="
						!showRenameValidationErrors ||
						renameValidationErrors.length === 0
					"
					class="form-text"
				>
					Anna pelille kuvaava nimi
				</div>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
			[disabled]="isRenamingInProgress"
		>
			Peruuta
		</button>

		<button
			type="button"
			class="btn btn-primary"
			(click)="submitRename()"
			[disabled]="!isRenameNameValid() || isRenamingInProgress"
		>
			<span
				*ngIf="isRenamingInProgress"
				class="spinner-border spinner-border-sm me-2"
				role="status"
				aria-hidden="true"
			></span>
			{{ isRenamingInProgress ? "Nimetään..." : "Hyväksy" }}
		</button>
	</div>
</ng-template>

<ng-template #archiveExportModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-archive-export-title">
			{{
				exportToArchive &&
				exportService.isExportArchived(exportToArchive.id)
					? "Palauta peli päänäkymään"
					: "Arkistoi peli"
			}}
		</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-archive-export-title"
			(click)="modal.dismiss('Cross click')"
			[disabled]="archiveExportInProgress"
		></button>
	</div>
	<div class="modal-body">
		<!-- Loading state -->
		<div *ngIf="archiveExportInProgress" class="text-center py-3">
			<div class="spinner-border text-primary mb-3" role="status">
				<span class="visually-hidden">{{
					exportToArchive &&
					exportService.isExportArchived(exportToArchive.id)
						? "Palautetaan..."
						: "Arkistoidaan..."
				}}</span>
			</div>
			<p class="mb-0">
				{{
					exportToArchive &&
					exportService.isExportArchived(exportToArchive.id)
						? "Palautetaan peliä..."
						: "Arkistoidaan peliä..."
				}}
			</p>
		</div>

		<!-- Error state -->
		<div *ngIf="archiveExportError" class="alert alert-danger" role="alert">
			<h5 class="alert-heading">Virhe</h5>
			<p class="mb-0">{{ archiveExportError }}</p>
		</div>

		<!-- Confirmation state -->
		<div *ngIf="!archiveExportInProgress && !archiveExportError">
			<p
				*ngIf="
					!(
						exportToArchive &&
						exportService.isExportArchived(exportToArchive.id)
					)
				"
			>
				Haluatko arkistoida pelin
				<strong>{{ exportToArchive?.name }}</strong
				>?
			</p>
			<p
				*ngIf="
					exportToArchive &&
					exportService.isExportArchived(exportToArchive.id)
				"
			>
				Haluatko palauttaa pelin
				<strong>{{ exportToArchive?.name }}</strong> takaisin
				päänäkymään?
			</p>

			<p
				class="text-muted small"
				*ngIf="
					!(
						exportToArchive &&
						exportService.isExportArchived(exportToArchive.id)
					)
				"
			>
				Peli katoaa päänäkymästä, mutta sen julkaisut säilyvät kuitenkin
				voimassa. Voit nähdä arkistoidut pelit kytkemällä päälle "Näytä
				arkistoidut" näkymän ylälaidassa.
			</p>
			<p
				class="text-muted small"
				*ngIf="
					exportToArchive &&
					exportService.isExportArchived(exportToArchive.id)
				"
			>
				Peli palautetaan takaisin näkyville päänäkymään.
			</p>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
			[disabled]="archiveExportInProgress"
		>
			{{ archiveExportError ? "Sulje" : "Peruuta" }}
		</button>

		<button
			*ngIf="!archiveExportError"
			type="button"
			class="btn btn-primary"
			(click)="executeArchiveExport(modal)"
			[disabled]="archiveExportInProgress"
		>
			<span
				*ngIf="archiveExportInProgress"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i
				*ngIf="!archiveExportInProgress"
				[class]="
					exportToArchive &&
					exportService.isExportArchived(exportToArchive.id)
						? 'bi bi-arrow-counterclockwise me-1'
						: 'bi bi-archive me-1'
				"
			></i>
			{{
				exportToArchive &&
				exportService.isExportArchived(exportToArchive.id)
					? "Palauta"
					: "Arkistoi"
			}}
		</button>
	</div>
</ng-template>

<ng-template #bulkArchiveModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-bulk-archive-title">
			Arkistoi valitut pelit
		</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-bulk-archive-title"
			(click)="modal.dismiss('Cross click')"
			[disabled]="bulkArchiveInProgress"
		></button>
	</div>
	<div class="modal-body">
		<!-- Loading state -->
		<div *ngIf="bulkArchiveInProgress" class="text-center py-3">
			<div class="spinner-border text-primary mb-3" role="status">
				<span class="visually-hidden">Arkistoidaan...</span>
			</div>
			<p class="mb-0">Arkistoidaan {{ selectedExports.size }} peliä...</p>
		</div>

		<!-- Error state -->
		<div *ngIf="bulkArchiveError" class="alert alert-danger" role="alert">
			<h5 class="alert-heading">Virhe arkistoinnissa</h5>
			<p class="mb-0">{{ bulkArchiveError }}</p>
		</div>

		<!-- Confirmation state -->
		<div *ngIf="!bulkArchiveInProgress && !bulkArchiveError">
			<p>
				Haluatko arkistoida
				<strong>{{ selectedExports.size }}</strong> valittua peliä?
			</p>

			<p class="text-muted small">
				Pelit katoavat päänäkymästä, mutta niiden julkaisut säilyvät
				kuitenkin voimassa. Voit nähdä arkistoidut pelit kytkemällä
				päälle "Näytä arkistoidut" näkymän ylälaidassa.
			</p>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
			[disabled]="bulkArchiveInProgress"
		>
			{{ bulkArchiveError ? "Sulje" : "Peruuta" }}
		</button>

		<button
			*ngIf="!bulkArchiveError"
			type="button"
			class="btn btn-primary"
			(click)="executeBulkArchive(modal)"
			[disabled]="bulkArchiveInProgress"
		>
			<span
				*ngIf="bulkArchiveInProgress"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i *ngIf="!bulkArchiveInProgress" class="bi bi-archive me-1"></i>
			Arkistoi pelit
		</button>
	</div>
</ng-template>

<ng-template #bulkDeleteModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-bulk-delete-title">
			Poista valitut pelit
		</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close button"
			aria-describedby="modal-bulk-delete-title"
			(click)="modal.dismiss('Cross click')"
			[disabled]="bulkDeleteInProgress"
		></button>
	</div>
	<div class="modal-body">
		<!-- Loading state -->
		<div *ngIf="bulkDeleteInProgress" class="text-center py-3">
			<div class="spinner-border text-primary mb-3" role="status">
				<span class="visually-hidden">Poistetaan...</span>
			</div>
			<p class="mb-0">
				Poistetaan {{ selectedExports.size }} peliä ja niiden
				julkaisut...
			</p>
		</div>

		<!-- Error state -->
		<div *ngIf="bulkDeleteError" class="alert alert-danger" role="alert">
			<h5 class="alert-heading">Virhe poistossa</h5>
			<p class="mb-0">{{ bulkDeleteError }}</p>
		</div>

		<!-- Confirmation state -->
		<div *ngIf="!bulkDeleteInProgress && !bulkDeleteError">
			<p>
				Haluatko poistaa
				<strong>{{ selectedExports.size }}</strong> valittua peliä?
			</p>

			<p class="text-muted small">
				<i class="bi bi-info-circle me-1"></i>
				Pelit ja niiden kaikki julkaisut poistetaan pysyvästi. Tätä
				toimintoa ei voi peruuttaa.
			</p>
		</div>
	</div>
	<div class="modal-footer">
		<button
			type="button"
			class="btn btn-secondary"
			(click)="modal.dismiss('Cancel click')"
			[disabled]="bulkDeleteInProgress"
		>
			{{ bulkDeleteError ? "Sulje" : "Peruuta" }}
		</button>

		<button
			*ngIf="!bulkDeleteError"
			type="button"
			class="btn btn-danger"
			(click)="executeBulkDelete(modal)"
			[disabled]="bulkDeleteInProgress"
		>
			<span
				*ngIf="bulkDeleteInProgress"
				class="spinner-border spinner-border-sm me-1"
				role="status"
				aria-hidden="true"
			></span>
			<i *ngIf="!bulkDeleteInProgress" class="bi bi-trash me-1"></i>
			Poista pelit
		</button>
	</div>
</ng-template>
